import {Avatar, Box, Divider, ListItemAvatar, ListItemText, MenuItem, MenuList, Typography,} from '@mui/material';
import {Check as CheckIcon,} from '@mui/icons-material';

/* eslint-disable react/prop-types */

const SchoolSwitcher = ({schools = [], currentSchoolId, onSchoolChange}) => {
    if (!schools.length) {
        return null;
    }
    const selectedSchool = schools.find(s => s.id === currentSchoolId);

    const handleSchoolSwitch = (e, school) => {
        e.stopPropagation();

        if (school.id === currentSchoolId) {
            return;
        }

        onSchoolChange(school);
    };

    const getSchoolInitials = (name) =>
        name
            .split(' ')
            .map((word) => word[0])
            .join('')
            .slice(0, 2)
            .toUpperCase();

    return (
        <Box>
            <Box sx={{px: 2, py: 1}}>
                <Typography variant="caption" color="text.secondary" sx={{fontWeight: 600}}>
                    Current School
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        mt: 1,
                        mb: 1
                    }}
                >
                    <Avatar
                        sx={{
                            width: 24,
                            height: 24,
                            bgcolor: 'grey.200',
                            color: 'text.secondary',
                            fontSize: '0.75rem',
                            fontWeight: 500,
                        }}
                    >
                        {getSchoolInitials(selectedSchool?.name || '')}
                    </Avatar>
                    <Box sx={{flexGrow: 1, minWidth: 0}}>
                        <Typography variant="body2" sx={{fontWeight: 500}} noWrap>
                            {selectedSchool?.name}
                        </Typography>
                    </Box>
                </Box>
            </Box>
            {
                schools.length > 1
                    ? <>
                        <Divider/>
                        <Box sx={{px: 1}}>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{fontWeight: 600, px: 1, py: 0.5, display: 'block'}}
                            >
                                Switch School ({schools.length})
                            </Typography>
                            <MenuList
                                sx={{
                                    maxHeight: 256,
                                    overflow: 'auto',
                                    py: 0,
                                }}
                            >
                                {schools.map((school) => (
                                    <MenuItem key={school.id} onClick={(e) => handleSchoolSwitch(e, school)}
                                              sx={{px: 1, py: 1}}>
                                        <ListItemAvatar sx={{minWidth: 40}}>
                                            <Avatar
                                                sx={{
                                                    width: 24,
                                                    height: 24,
                                                    bgcolor: 'grey.200',
                                                    color: 'text.secondary',
                                                    fontSize: '0.75rem',
                                                    fontWeight: 500,
                                                }}
                                            >
                                                {getSchoolInitials(school.name)}
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={
                                                <Typography variant="body2" sx={{fontWeight: 500}} noWrap>
                                                    {school.name}
                                                </Typography>
                                            }
                                            sx={{mr: 1}}
                                        />
                                        {school.id === selectedSchool.id && <CheckIcon fontSize="small" color="primary"/>}
                                    </MenuItem>
                                ))}
                            </MenuList>
                        </Box>
                    </>
                    : null
            }
        </Box>
    );
};

export default SchoolSwitcher;
